import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Input } from '@material-ui/core'
import AddBtn from 'components/AddBtn'

const ProgramPhaseToolbar = props => {
  const { params, handleSearchChange, history } = props

  return (
    <Grid container item xs={12}>
      <Grid item xs={2}>
        <Input
          placeholder="Program Name"
          value={params.programName}
          onChange={event => handleSearchChange(event.target.value)}
        />
      </Grid>
      <Grid item xs={8} />
      <Grid container item xs={2} justify="flex-end">
        <AddBtn
          color="primary"
          type="submit"
          style={{ marginRight: 0 }}
          onClick={e => {
            e.stopPropagation()
            history.push(`/program-phases/add`)
          }}
          variant="contained">
          Add
        </AddBtn>
      </Grid>
    </Grid>
  )
}

ProgramPhaseToolbar.propTypes = {
  className: PropTypes.string,
}

export default ProgramPhaseToolbar
